/** Payment method chip labels used across booking/payment flows. */
export const PAYMENT_METHOD_CHIPS = [
  'ONLINE',
  'CASH',
  'CARD',
  'BANK TRANSFER',
  'COMPANY SETTLEMENT',
  'UPI',
  'CREDIT SALE',
  'CHEQUE',
  'PAYMENT LINK',
  'CASH DEPOSIT',
];

const DISPLAY_TO_CHIP = {
  online: 'ONLINE',
  cash: 'CASH',
  card: 'CARD',
  'credit card': 'CARD',
  credit_card: 'CARD',
  'debit card': 'DEBIT_CARD',
  debit_card: 'DEBIT_CARD',
  'bank transfer': 'BANK TRANSFER',
  bank_transfer: 'BANK TRANSFER',
  'company settlement': 'COMPANY SETTLEMENT',
  company_settlement: 'COMPANY SETTLEMENT',
  upi: 'UPI',
  'credit sale': 'CREDIT SALE',
  credit_sale: 'CREDIT SALE',
  cheque: 'CHEQUE',
  'payment link': 'PAYMENT LINK',
  payment_link: 'PAYMENT LINK',
  'cash deposit': 'CASH DEPOSIT',
  cash_deposit: 'CASH DEPOSIT',
  wallet: 'WALLET',
  'digital wallet': 'WALLET',
  other: 'OTHER',
};

function normalizeKey(method) {
  return String(method || '')
    .trim()
    .toUpperCase()
    .replace(/-/g, ' ')
    .replace(/_/g, ' ');
}

/**
 * Normalize any payment method string to the chip label sent to the API.
 * Preserves user-selected methods (e.g. ONLINE) instead of collapsing to OTHER.
 */
export function normalizePaymentMethodForApi(method) {
  if (!method) return 'CASH';

  const raw = String(method).trim();
  const upperSpaced = normalizeKey(raw);

  if (PAYMENT_METHOD_CHIPS.includes(upperSpaced)) {
    return upperSpaced;
  }

  const fromDisplay = DISPLAY_TO_CHIP[raw.toLowerCase()];
  if (fromDisplay) {
    return fromDisplay;
  }

  const fromNormalizedDisplay = DISPLAY_TO_CHIP[upperSpaced.toLowerCase()];
  if (fromNormalizedDisplay) {
    return fromNormalizedDisplay;
  }

  if (upperSpaced === 'CREDIT CARD') return 'CARD';
  if (upperSpaced === 'DEBIT CARD') return 'DEBIT_CARD';

  const lower = raw.toLowerCase();
  if (lower.includes('bank') && lower.includes('transfer')) return 'BANK TRANSFER';
  if (lower.includes('company') && lower.includes('settlement')) return 'COMPANY SETTLEMENT';
  if (lower.includes('credit') && lower.includes('sale')) return 'CREDIT SALE';
  if (lower.includes('payment') && lower.includes('link')) return 'PAYMENT LINK';
  if (lower.includes('cash') && lower.includes('deposit')) return 'CASH DEPOSIT';
  if (lower.includes('online')) return 'ONLINE';
  if (lower.includes('upi')) return 'UPI';
  if (lower.includes('cheque') || lower.includes('check')) return 'CHEQUE';
  if (lower.includes('wallet')) return 'WALLET';
  if (lower.includes('debit')) return 'DEBIT_CARD';
  if (lower.includes('credit') || lower.includes('card')) return 'CARD';
  if (lower.includes('cash')) return 'CASH';

  return upperSpaced || 'CASH';
}

/** Map stored/display payment method back to chip label for UI selection. */
export function paymentMethodToChipLabel(method) {
  return normalizePaymentMethodForApi(method);
}

export function formatPaymentMethodChipLabel(method) {
  if (method === 'UPI') return 'UPI';
  return String(method || '')
    .toLowerCase()
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
}
